import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  standalone: true,
  name: 'coverImage'
})
export class CoverImagePipe implements PipeTransform {

    private url: string = environment.api + '/images/coverImage/';

    transform(image: string | undefined): string {
      if (!image) {
        return '';
      }
      return this.url + image;
    }
}